module.exports = "/_next/static/images/header-phone-532b9aed1b9f908bc048aed8bcebf554.svg";